import { render, staticRenderFns } from "./DFrame.vue?vue&type=template&id=62ea38de&scoped=true"
import script from "./DFrame.vue?vue&type=script&lang=js"
export * from "./DFrame.vue?vue&type=script&lang=js"
import style0 from "./DFrame.vue?vue&type=style&index=0&id=62ea38de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ea38de",
  null
  
)

export default component.exports